<template>
  <base-view title="Integrar produtos - ERP" class="mb-5 mr-4">
    <b-row class="mb-5">
      <b-col cols="12" class="mb-3">
        <div class="mb-2">Selecione o ERP que deseja integrar:</div>

        <b-alert show class="fs-14">
          <i class="fas fa-info-circle mr-1"></i> <b>Observação:</b> Só é
          possível realizar a integração dos produtos com um ERP por vez, pois
          cada plataforma possui um processo de integração diferente.
        </b-alert>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center" v-if="loadingERPs">
        <b-spinner small class="mr-2" /> Carregando ERPs
      </b-col>
      <b-col cols="12" class="d-flex align-items-center">
        <ERPSelectCard
          v-for="erp in erps"
          :key="erp.id"
          :erp="erp"
          :selected-erp="selectedErp || {}"
          @select="handleERPSelection(erp)"
          class="mr-4"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      align-v="center"
      v-if="(selectedErp || {}).id"
    >
      <b-col v-if="Object.keys(selectedErp).length">
        <component :is="erpIntegrationScreen" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
        class="d-flex flex-column align-items-center mb-4"
      >
        <b-spinner label="Spinning" class="mb-2"> </b-spinner>
        Carregando seus produtos...
      </b-col>
    </b-row>
  </base-view>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import EnabledIntegrationStatus from 'Enums/Integration/EnabledIntegrationStatus';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

import ERPSelectCard from './_components/ERPSelectCard.vue';
import ERPMapFolder from './_components/map-folder';

export default {
  name: 'ERPIntegrateProducts',
  mixins: [makeToast],
  components: {
    ERPSelectCard,
  },
  data() {
    return {
      EnabledIntegrationStatus,
      IntegrationTypes,
      loading: false,
      loadingERPs: false,
      selectedErp: {},
      erps: [],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),

    erpIntegrationScreen() {
      if (!this.selectedErp || !this.selectedErp.type) return;

      const folder = ERPMapFolder[this.selectedErp.type];

      return () => import(`./_components/${folder}/Integrate.vue`);
    },
  },
  mounted() {
    this.getERPs();
  },
  methods: {
    async getERPs() {
      this.loadingERPs = true;

      const { data } = await shopkeeperAppApi.get(
        `/integration/erp/${this.userTypeId()}/integrations`
      );

      this.loadingERPs = false;

      this.erps = data.data || [];
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    handleERPSelection(erp) {
      if (!erp.enabledIntegration) return;

      if (erp.enabledIntegration.status !== EnabledIntegrationStatus.ACTIVE)
        return;

      if (this.selectedErp.id === erp.id) {
        this.selectedErp = {};
        return;
      }

      this.selectedErp = erp;
    },
  },
};
</script>
